import { footerInfo } from '@/mocks/zh/common';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="inline-flex items-center gap-2 mb-6">
              <div className="w-10 h-10 bg-accent-500 rounded-lg flex items-center justify-center">
                <i className="ri-fire-line text-xl text-foreground-950"></i>
              </div>
              <span className="font-heading text-2xl font-bold">{footerInfo.brandName}</span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-sm mb-6">
              {footerInfo.description}
            </p>
            <div className="flex items-center gap-3">
              {footerInfo.socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  rel="nofollow"
                  className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-accent-500 hover:border-accent-500 transition-colors"
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">
              {footerInfo.address.label}
            </h4>
            <div className="space-y-1 mb-8">
              {footerInfo.address.lines.map((line, i) => (
                <p key={i} className="text-sm text-foreground-300">{line}</p>
              ))}
            </div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">
              {footerInfo.phone.label}
            </h4>
            <div className="space-y-1 mb-8">
              {footerInfo.phone.lines.map((line, i) => (
                <p key={i} className="text-sm text-foreground-300">{line}</p>
              ))}
            </div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">
              {footerInfo.email.label}
            </h4>
            <div className="space-y-1">
              {footerInfo.email.lines.map((line, i) => (
                <p key={i} className="text-sm text-foreground-300">{line}</p>
              ))}
            </div>
          </div>

          <div className="md:col-span-4 flex items-start justify-end">
            <div className="w-48 h-64 rounded-xl overflow-hidden bg-foreground-800">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20media%20newsroom%20with%20multiple%20screens%20displaying%20trending%20topics%2C%20warm%20ambient%20lighting%2C%20professional%20broadcast%20studio%20setting%2C%20dark%20sophisticated%20interior%20with%20neon%20accent%20lights%2C%20editorial%20office%20photography%2C%20cinematic%20composition%20with%20shallow%20depth%20of%20field%2C%20modern%20minimalist%20aesthetic&width=480&height=640&seq=footer-image-01&orientation=portrait"
                alt="51黑料网编辑部"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            {footerInfo.copyright || '© 2026 51黑料网 版权所有'}
          </p>
          <div className="flex items-center gap-6">
            {footerInfo.bottomLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="text-xs text-foreground-400 hover:text-accent-500 transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}